(function() {
    angular
        .module("app")
        .factory("customersService", customersService)

    customersService.$inject = [
        "$rootScope",
        "$http",
        "queryStringService"
    ]

    function customersService(
        $rootScope,
        $http,
        queryStringService
    ) {
        var service = {}

        const maxCustomers = 3000

        /**
            Get all customers PROMISE
            @returns {*}
         **/
        service.getAllCustomersWithCPUPromise = function() {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/customers?"
                + "perpage=" + maxCustomers
                + "&cpu=" + true
            }).then(getAllCustomersWithCPUPromiseComplete, getAllCustomersWithCPUPromiseFailed)

            function getAllCustomersWithCPUPromiseComplete(response) {
                return response.data
            }

            function getAllCustomersWithCPUPromiseFailed(error) {
                console.error(error)
            }
        }

        /**
            Get customers
            @param {boolean} forceAll
            @param {func?}   successCallback
            @param {func?}   failureCallback
         **/
        service.getCustomers = function(successCallback, failureCallback) {

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/customers?"
                + "perpage=" + maxCustomers
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        /**
            Get single customer
            @param {int}   customerID
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.getCustomer = function(customerID, successCallback, failureCallback) {

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/customers/" + customerID
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.createCustomer = function(formData, successCallback, failureCallback) {

            var queryJson = queryStringService.createQueryJson(formData, "customer")

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/customers/",
                data: queryJson
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.editCustomer = function(customerID, formData, successCallback, failureCallback) {

            var queryJson = queryStringService.createQueryJson(formData, "customer")

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/customers/" + customerID,
                data: queryJson
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.deleteCustomer = function(customerID, successCallback, failureCallback) {

            $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/customers/" + customerID
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.createApiConfig = function(customerID, formData, successCallback, failureCallback) {

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/api_configs",
                data: formData
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.createDOT = function(customerID, formData, successCallback, failureCallback) {

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/dot",
                data: formData
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.deleteDOT = function(customerID, successCallback, failureCallback) {

            $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/dot"
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.updateDOTRegionAccess = (customerID, regionRead, regionWrite, successCallback, failureCallback) => {

            const success = (response) => {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            const failure = (error) => {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/region_access",
                data: {
                    region_read:  regionRead,
                    region_write: regionWrite
                }
            }).then(success, failure)
        }

        service.createWZDxConfig = function(customerID, formData, successCallback, failureCallback) {

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/wzdx_config",
                data: formData
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.updateApiConfig = function(customerID, apiConfigID, formData, successCallback, failureCallback) {

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/api_configs/" + apiConfigID,
                data: formData
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.deleteApiConfig = function(customerID, apiConfigID, successCallback, failureCallback) {

            $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/api_configs/" + apiConfigID
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.deleteWZDxConfig = function(customerID, wzdxConfigID, successCallback, failureCallback) {

            $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/customers/" + customerID + "/wzdx_config/" + wzdxConfigID
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.searchCustomers = function(searchData, page, perPage, minimumTimeMs, successCallback, failureCallback) {

            const start = new Date().getTime()

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/customers/search?"
                + "search=" + searchData
                + "&page=" + page
                + "&perpage=" + perPage
            }).then(success, failure)

            function success(response) {
                setTimeout(() => {
                    if (successCallback !== undefined) {
                        successCallback(response.data, response.headers("Total"))
                    }
                }, Math.min(0, minimumTimeMs - (new Date().getTime() - start)))
            }

            function failure(error) {
                setTimeout(() => {
                    console.error(error)
                    if (failureCallback !== undefined) {
                        failureCallback(error)
                    }
                }, Math.min(0, minimumTimeMs - (new Date().getTime() - start)))
            }
        }

        return service
    }
})()
